import { render, staticRenderFns } from "./fourthBlogRow.vue?vue&type=template&id=8514db02&"
import script from "./fourthBlogRow.vue?vue&type=script&lang=js&"
export * from "./fourthBlogRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports